export default __webpack_public_path__ + "static/cellist-95349131c4749dc3f8707c6790e64358.jpg";